import { Link } from '../navigation'
import { ChartContainer } from '../cockpit/Graphs'
import type { PanelType } from '../cockpit/Graphs'
import { useFxContext } from '../forecast/FxProvider'
import { useSingleTeamMangement } from '../Management'
import { ForecastChart, projectCosts, RunningEntry } from './Forecast'
import { useRunningCosts } from './RunningCostProvider'

export function IpManagementForecastPanel({
    panelType,
    panelId,
    panelName,
}: {
    panelType: PanelType,
    panelId: number,
    panelName: string,
}) {
    const { team } = useSingleTeamMangement()
    const targetCurrency = team?.currency ?? 'EUR'
    const { fxConverter } = useFxContext()
    const { runningCosts } = useRunningCosts()

    const entries: RunningEntry[] = runningCosts.map(c => ({
        tag: c.tag,
        vendor: c.vendor,
        source: c.source,
        date: c.date,
        amount: String(c.amount),
        currency: c.currency,
        vat: String(c.vat),
        comment: c.comment,
    }))

    const data = projectCosts(entries, fxConverter, targetCurrency)

    return (
        <ChartContainer panelType={panelType} panelId={panelId} panelName={panelName}>
            <h2 className="pb-1">
                <Link to="/management/forecast">Total forecast</Link>
            </h2>
            <ForecastChart data={data} yAxisWidth={30} />
            <div className="text-slate-500 text-xs w-full pl-2 mt-2">
                <div className="inline-flex gap-2 items-center"><div className="h-4 w-4 bg-pcx-500" />Costs ({targetCurrency})</div>
            </div>
        </ChartContainer>
    )
}
